export default __webpack_public_path__ + "static/media/flag.b57e94ef.svg";